import React, { FC, useMemo, useState } from 'react';

import './styles.scss';

const OPTIONS = ['ALL', '90', '80', '75', '30'] as const;

export type BingoFilterValue = (typeof OPTIONS)[number];

type BingoFilterProps = {
  initial?: BingoFilterValue;
  onChange?: (value: BingoFilterValue) => void;
};

export const BingoFilter: FC<BingoFilterProps> = ({ initial = 'ALL', onChange }) => {
  const normalizedInitial = useMemo(() => (OPTIONS.includes(initial) ? initial : 'ALL'), [initial]);
  const [value, setValue] = useState<BingoFilterValue>(normalizedInitial);

  const handleClick = (next: BingoFilterValue): void => {
    setValue(next);
    onChange?.(next);
  };

  return (
    <div className="bingo-filter">
      {OPTIONS.map((option) => (
        <button
          type="button"
          key={option}
          className={`bingo-filter__option ${option === value ? 'bingo-filter__option--active' : ''}`}
          onClick={(): void => handleClick(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
